// extracted by mini-css-extract-plugin
export default {"dark":"Copyright-module--dark--2cde7","copyright":"Copyright-module--copyright--aefad"};